import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { darken } from '@mui/system';

const HButton = styled(Button)(({ padding, fontSize, fontWeight, margin, textColor, backgroundColor, borderRadius, primaryBtn, outline, minWidth, boxShadow }) => ({
    padding: padding || '4px 12px',
    fontSize: fontSize || '13px',
    margin: margin || '0px 8px',
    color: outline ? '#1877F2' : textColor || (primaryBtn ? '#fff' : '#4D4848'),
    backgroundColor: outline ? 'transparent' : (backgroundColor || (primaryBtn ? '#1877F2' : '#F2F2F2')),
    border: outline ? '1px solid #1877F2 !important' : 'none',
    borderColor: outline ? (textColor || (primaryBtn ? '#1877F2' : '#4D4848')) : 'none',
    fontWeight: fontWeight || '600',
    textTransform: 'capitalize',
    borderRadius: borderRadius || '4px',
    lineHeight: '20px',
    fontFamily: '"Open Sans", sans-serif',
    letterSpacing: 'normal',
    minWidth: minWidth || 'fit-content',
    boxShadow: boxShadow || 'none',
    '&:hover': {
        backgroundColor: outline ? 'transparent' : (backgroundColor ? darken(backgroundColor, 0.2) : darken(primaryBtn ? '#1877F2' : '#F2F2F2', 0.2)),
        borderColor: outline ? darken(textColor || (primaryBtn ? '#1877F2' : '#4D4848'), 0.2) : 'none',
    },
}));

export default function CustomButton(props) {
    const { textColor, color, className, ...otherProps } = props;

    return (
        <HButton {...otherProps} textColor={textColor} className={className}>
            {props.children}
        </HButton>
    );
}
